export const CONTEXT_HINT_QUESTION_TYPES = new Set([
    "radio",
    "check",
    "dropDown",
    "yesNo",
    "textShort",
    "textLong",
    "number",
    "date",
    "time",
    "bloodPressure",
    "bodyMetrics"
]);
export function contextHintPolicy(config) {
    const raw = config && typeof config === "object" && !Array.isArray(config)
        ? config.contextHints
        : undefined;
    if (!raw || typeof raw !== "object" || Array.isArray(raw)) {
        return {};
    }
    const policy = raw;
    return {
        enabled: typeof policy.enabled === "boolean" ? policy.enabled : undefined,
        allowedValues: Array.isArray(policy.allowedValues)
            ? policy.allowedValues.filter((v) => typeof v === "string")
            : undefined
    };
}
const fold = (value) => value.trim().toLowerCase();
export function contextHintingEnabled(question) {
    return (CONTEXT_HINT_QUESTION_TYPES.has(question.type) &&
        contextHintPolicy(question.config).enabled !== false);
}
/** Keep filtering decisions here so defaults can change without rewriting stored questions. */
export function contextHintAnswerAllowed(question, value) {
    if (!contextHintingEnabled(question) || !value.trim()) {
        return false;
    }
    const options = question.options ?? [];
    const option = options.find((o) => fold(o.value) === fold(value) || fold(o.label) === fold(value));
    const canonical = option?.value ?? value;
    const allowed = contextHintPolicy(question.config).allowedValues;
    if (allowed !== undefined) {
        return allowed.some((v) => fold(v) === fold(canonical));
    }
    const yesNo = question.type === "yesNo" ||
        (options.length === 2 &&
            options.some((o) => fold(o.label) === "yes") &&
            options.some((o) => fold(o.label) === "no"));
    return !(yesNo && [canonical, option?.label ?? value].some((v) => fold(v) === "no"));
}
//# sourceMappingURL=context-hint-policy.js.map